if ($('.business-dropdown').val() === 'Other') {
    $('.businessTypeOther').show();
} else {
    $('.businessTypeOther').hide();
}

$('.business-dropdown').on('change', function () {

    if ($(this).find('option:selected').val() === 'Other') {
        $('.businessTypeOther').show();
    } else {
        $('.businessTypeOther').hide();
    }
});

$('.create-customer-phone').blur(function () {
    this.value = this.value.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
});